import { inject, Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, map, take, catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { UserStore } from 'src/app/core/auth/user/store/user.store';
import { InviteService } from 'src/app/core/auth/services/invite.service';

@Injectable({ providedIn: 'root' })
export class LayoutResolver implements Resolve<boolean> {
  // Signals-to-Observable in an injection context (field initializers)
  private roles$: Observable<any[]>;
  private user$: Observable<any>;

  private messageService = inject(MessageService);

  constructor(private userStore: UserStore, private inviteService: InviteService, ) {
    // toObservable in constructor is valid injection context
    this.roles$ = toObservable(this.userStore.roles);
    this.user$ = toObservable(this.userStore.user);
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // Starte Laden der Rolle und des Users
    this.inviteService.acceptInvites().subscribe({
          next: (invites) => {
            if (invites.length > 0) {
              console.debug('Invites accepted successfully');
              this.messageService.add({ severity: 'info', summary: 'Einladungen angenommen', detail: 'Alle Einladungen wurden erfolgreich angenommen.' });
            }

            this.userStore.loadRoles();
            this.userStore.loadUser();
          },
          error: (error) => {
            console.error('Error accepting invites:', error);
          }
        });
    

    // Warte auf erste nicht-leeren Werte
    return combineLatest([
      this.roles$,
      this.user$
    ] as const).pipe(
      filter(([roles, user]) => roles.length > 0 && !!user),
      take(1),
      map(() => true),
      catchError(() => of(false))
    );
  }
}